import SectionContainer from '@/app/components/SectionContainer';

import { JobCategoryButton } from './JobCategoryButton/JobCategoryButton';
import styles from './JobsSection.module.scss';
import anaesthetics from './assets/anaesthetics.jpg';
import emergencyMedicine from './assets/emergencyMedicine.jpg';
import generalMedicine from './assets/generalMedicine.jpg';
import gp from './assets/gp.jpg';
import intensiveCare from './assets/intensiveCare.jpg';
import obstetrics from './assets/obstetrics.jpg';
import paediatrics from './assets/paediatrics.jpg';
import psychiatry from './assets/psychiatry.jpg';
import surgery from './assets/surgery.jpg';

const jobButtons = [
  {
    title: 'Emergency Medicine',
    url: '/doctors/ed-doctors-jobs-australia',
    imageSrc: emergencyMedicine,
  },
  {
    title: 'General Medicine',
    url: '/doctors/general-medicine-doctor-jobs-australia',
    imageSrc: generalMedicine,
  },
  { title: 'Psychiatry', url: '/doctors/psychiatry-doctor-jobs-australia', imageSrc: psychiatry },
  {
    title: 'Intensive Care',
    url: '/doctors/icu-consultant-jobs-australia',
    imageSrc: intensiveCare,
  },
  { title: 'Surgery', url: '/doctors/surgeon-doctor-jobs', imageSrc: surgery },
  {
    title: 'Anaesthetics',
    url: '/doctors/anaesthetics-doctor-jobs-australia',
    imageSrc: anaesthetics,
  },
  {
    title: 'Paediatrics',
    url: '/doctors/paediatrics-doctor-jobs-australia',
    imageSrc: paediatrics,
  },
  {
    title: 'Obstetrics and Gynaecology',
    url: '/doctors/obstetrics-and-gynaecology-jobs-australia',
    imageSrc: obstetrics,
  },
  { title: 'GP', url: '/doctors/gp-jobs-australia', imageSrc: gp },
];

export const JobsSection = () => (
  <SectionContainer className={styles.jobsSectionContainer}>
    <div>
      <h3 className={styles.jobsSectionTitle}>
        Explore the <span>largest network of doctor jobs </span>in Australasia
      </h3>
    </div>

    <div className={styles.jobsGrid}>
      {jobButtons.map(job => (
        <JobCategoryButton key={job.title} {...job} />
      ))}
    </div>
  </SectionContainer>
);
